























































import {Component, Vue} from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import PropertyData from '@/ts/PropertyData';
import BuildingData from '@/ts/BuildingData';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class PropertyList extends Vue {
    public selectedProperties: any = [];
    public tableEntity: string = 'PropertyList';

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'titleNumber', label: this.$t('general.unit-id', 'Unit  ID'), align: 'left', field: 'titleNumber', sortable: true, required: true },
            { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true, required: false },
            { name: 'type', label: this.$t('general.unit-type', 'Variant'), align: 'left', field: 'type', sortable: true, required: false },
            { name: 'unitType', label: this.$t('general.unit-type-ub', 'Unit Type'), align: 'left', field: 'unitType', sortable: true, required: false },
            { name: 'companyName', label: this.$t('general.resident', 'Resident'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) => {
                    if (row.isCommercial) {
                        return row.companyName;
                    }

                    return !row.directOwnerId ? this.$t('general.na', 'N/A') : this.ownerName(row);
                },
            },
            { name: 'area', label: this.$t('general.area', 'Area'), align: 'left', field: 'area', sortable: true, required: false },
            { name: 'rentAmount', label: this.$t('general.rent', 'Rent'), align: 'left', field: 'rentAmount', sortable: true, required: false },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'titleNumber',
                'address',
                'type',
            ],
        };
    }

    get filteredProperties(): PropertyData[] {
        const properties = this.$store.state.Properties.properties.filter((property: PropertyData) => property.persisted);

        if (this.$store.getters['Buildings/selectedBuildings'].length > 0) {
            return properties.filter((property: PropertyData) => {
                return this.$store.getters['Buildings/selectedBuildingIds'].includes(property.buildingId);
            });
        }

        // If there is applied project selections
        const projectId = this.$store.state.Projects.activeProjectId;
        if (projectId !== null) {
            const buildingIds = this.$store.state.Buildings.buildings
                .filter((building: BuildingData) => {
                    return (building.projectId === projectId);
                })
                .map((building: BuildingData) => building.id);

            return properties.filter((property: PropertyData) => {
                return buildingIds.includes(property.buildingId);
            });
        }

        return properties;
    }

    get getSelectedProperties() {
        return this.getPropertyData.filter((item: any) => item.selected);
    }

    get getPropertyData(): any {
        return this.$store.getters['Properties/allProperties'];
    }

    get selectedBuildings(): number {
        return this.$store.getters['Buildings/selectedBuildings'];
    }

    get filteredBuildings() {
        const properties = this.$store.state.Properties.properties;
        const buildingId = this.$store.state.Buildings.activeBuildingId;

        return properties.filter((item: any) => {
            return item.buildingId === buildingId;
        });
    }

    public goToUnit(id: number) {
        this.$router.push({ name: 'admin-unit-details', params: { unitId: id.toString() }});
    }

    public ownerName(property: any): string {
        if (property.ownerId === null && property.directOwnerId === null) {
            return '';
        }
        const ownerId = property.directOwnerId !== null ? property.directOwnerId : property.ownerId;
        const owner = this.$store.getters['User/getCacheUser'](ownerId);

        return (owner) ? this.$store.getters['User/getCacheUser'](ownerId).fullName : '';
    }

    public createPropertyConversation(propertyId: number) {
        this.$store.dispatch(Actions.INITIALIZE_PROPERTY_CONVERSATION, propertyId)
            .then(() => {
                this.$router.push('/admin/messages');
            });
    }

    public addUserForm(formKey: string, itemId: any) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_PROPERTY, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_PROPERTY);
        this.$store.commit(Mutations.SHOW_ADD_USER_TO_PROPERTY_FORM, formKey);
    }

    public slideInForm(formKey: string, itemId: any) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_PROPERTY, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_PROPERTY);
        this.$store.commit(Mutations.SHOW_EDIT_PROPERTY_FORM, formKey);
    }

    public toggleItem(properties: any) {
        const allProperties = this.$store.getters['Properties/allProperties'];
        const propertyIds = properties.map((property: BuildingData) => property.id);

        allProperties.forEach((property: any) => {
            if (propertyIds.includes(property.id)) {
                this.$store.commit(Mutations.SELECT_PROPERTY, property.id);
            } else {
                this.$store.commit(Mutations.DESELECT_PROPERTY, property.id);
            }
        });
    }

    public deleteUnit(unitId: number, unitName: any): void {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Properties/DELETE_UNIT',
            confirmActionData: {unitId},
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-unit', 'Are you sure you want to delete this unit?'),
            confirmInfoText: unitName,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-trash',
            confirmHeaderText: this.$t('forms.delete-unit', 'Delete Unit'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public created() {
        this.selectedProperties = this.getSelectedProperties;
    }

    public canEditUnit(rowData) {
        let canEdit = true;
        const { externalId } = rowData;
        const currentCorporation = this.$store.getters['Corporations/getCurrentCorporation'];

        if (currentCorporation) {
            if (externalId || currentCorporation.lock_master_data) {
                canEdit = false;
            }
        }

        return canEdit;
    }
}
